const cookieUtil = {
  setCookie(name, value) {
    document.cookie = `${name}=${value}`;
  }
};

export default cookieUtil;
